// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import displayINRCurrency from "../helpers/displayCurrency";
// import addToCart from "../helpers/addToCart";
// import { useDispatch } from "react-redux";
// import { motion } from "framer-motion";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import "swiper/css";

// const ProductDetails = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const [data, setData] = useState({});
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [qty, setQty] = useState(1);
//   const [recommended, setRecommended] = useState([]);

//   // 🔥 FETCH PRODUCT
//   const fetchProduct = async () => {
//     const res = await fetch("https://lappyshop.onrender.com/api/product-details", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ productId: id }),
//     });

//     const result = await res.json();
//     const product = result.data;

//     setData(product);

//     // ✅ FIX: default variant
//     if (product?.variants?.length > 0) {
//       setSelectedVariant(product.variants[0]);
//     }
//   };

//   // 🔥 FETCH RECOMMENDED
//   const fetchRecommended = async () => {
//     const res = await fetch("https://lappyshop.onrender.com/api/get-product");
//     const result = await res.json();

//     if (result.success) {
//       setRecommended(result.data.slice(0, 10));
//     }
//   };

//   useEffect(() => {
//     fetchProduct();
//     fetchRecommended();
//   }, [id]);

//   // 🔥 AUTO IMAGE SLIDER
//   useEffect(() => {
//     if (!data?.productImage?.length) return;

//     const interval = setInterval(() => {
//       setActiveIndex((prev) => (prev + 1) % data.productImage.length);
//     }, 4000);

//     return () => clearInterval(interval);
//   }, [data]);

//   const activeImage = data?.productImage?.[activeIndex];

//   // 🔥 VARIANT FIX
//   const handleVariantChange = (type, value) => {
//     if (!data?.variants) return;

//     let newVariant;

//     if (type === "ram") {
//       newVariant = data.variants.find(
//         (v) =>
//           v.ram === value &&
//           v.storage === selectedVariant?.storage
//       );
//     } else {
//       newVariant = data.variants.find(
//         (v) =>
//           v.storage === value &&
//           v.ram === selectedVariant?.ram
//       );
//     }

//     if (newVariant) setSelectedVariant(newVariant);
//   };

//   // 🔥 PRICE FIX (NO NaN)
//   const price = selectedVariant?.price || 0;
//   const actual = data?.price || price;

//   const discount =
//     actual > price ? Math.round(((actual - price) / actual) * 100) : 0;

//   return (
//     <div className="bg-[#f6f7fb] min-h-screen py-6 px-3">

//       <div className="max-w-7xl mx-auto">

//         {/* 🔥 TOP SECTION */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-white rounded-2xl p-5 shadow">

//           {/* LEFT IMAGE */}
//           <div>

//             {/* MAIN IMAGE */}
//             <div className="relative group overflow-hidden rounded-xl bg-gray-100">
//               <motion.img
//                 key={activeImage}
//                 src={activeImage}
//                 alt="product"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 className="w-full h-[300px] md:h-[420px] object-contain transition duration-500 group-hover:scale-125"
//               />
//               <div className="absolute inset-0 bg-gradient-to-tr from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition"></div>
//             </div>

//             {/* THUMBNAILS */}
//             <div className="flex gap-2 mt-3 overflow-x-auto">
//               {data?.productImage?.slice(0, 6).map((img, i) => (
//                 <img
//                   key={i}
//                   src={img}
//                   alt=""
//                   onClick={() => setActiveIndex(i)}
//                   className={`w-16 h-16 object-cover rounded cursor-pointer border 
//                   ${activeIndex === i ? "border-red-500" : ""}`}
//                 />
//               ))}
//             </div>

//           </div>

//           {/* RIGHT */}
//           <div>

//             <h1 className="text-xl md:text-2xl font-bold">
//               {data.productName}
//             </h1>

//             {/* PRICE */}
//             <div className="mt-3">
//               <p className="text-3xl font-bold text-red-600">
//                 {displayINRCurrency(price)}
//               </p>

//               <div className="flex gap-3 text-sm">
//                 <span className="line-through text-gray-400">
//                   {displayINRCurrency(actual)}
//                 </span>
//                 <span className="text-green-600 font-semibold">
//                   {discount}% OFF
//                 </span>
//               </div>
//             </div>

//             {/* VARIANTS */}
//             <div className="mt-5">

//               <p className="font-medium">RAM</p>
//               <div className="flex gap-2 mt-2 flex-wrap">
//                 {[...new Set(data?.variants?.map(v => v.ram))].map((ram) => (
//                   <button
//                     key={ram}
//                     onClick={() => handleVariantChange("ram", ram)}
//                     className={`px-4 py-1 rounded-lg border 
//                     ${selectedVariant?.ram === ram ? "bg-black text-white" : ""}`}
//                   >
//                     {ram}
//                   </button>
//                 ))}
//               </div>

//               <p className="font-medium mt-4">Storage</p>
//               <div className="flex gap-2 mt-2 flex-wrap">
//                 {[...new Set(data?.variants?.map(v => v.storage))].map((s) => (
//                   <button
//                     key={s}
//                     onClick={() => handleVariantChange("storage", s)}
//                     className={`px-4 py-1 rounded-lg border 
//                     ${selectedVariant?.storage === s ? "bg-black text-white" : ""}`}
//                   >
//                     {s}
//                   </button>
//                 ))}
//               </div>

//             </div>

//             {/* QTY */}
//             <div className="flex items-center gap-3 mt-5">
//               <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>-</button>
//               <span>{qty}</span>
//               <button onClick={() => setQty(qty + 1)}>+</button>
//             </div>

//             {/* BUTTONS */}
//             <div className="flex gap-3 mt-6 flex-col sm:flex-row">
//               <button
//                 onClick={() => addToCart(data._id, selectedVariant, dispatch, qty)}
//                 className="flex-1 bg-red-600 text-white py-3 rounded-xl hover:bg-red-700 hover:scale-105 transition"
//               >
//                 Add to Cart
//               </button>

//               <button
//                 onClick={() => {
//                   addToCart(data._id, selectedVariant, dispatch, qty);
//                   window.location.href = "/checkout";
//                 }}
//                 className="flex-1 bg-black text-white py-3 rounded-xl"
//               >
//                 Buy Now
//               </button>
//             </div>

//           </div>

//         </div>

//         {/* 🔥 DESCRIPTION */}
//         <div className="bg-white mt-6 p-5 rounded-xl shadow">
//           <h2 className="text-lg font-semibold">Description</h2>
//           <p className="text-gray-600 mt-2">
//             {data.description || "High quality refurbished laptop with warranty."}
//           </p>
//         </div>

//         {/* 🔥 SPECIFICATIONS */}
//         <div className="bg-white mt-6 p-5 rounded-xl shadow">

//           <h2 className="text-lg font-semibold mb-4">
//             Technical Specifications
//           </h2>

//           <div className="grid md:grid-cols-3 gap-4 text-sm">

//             <div className="border p-4 rounded-xl">
//               <h3 className="font-semibold mb-2">Performance</h3>
//               <p>Processor: {data.processor || "Intel i5"}</p>
//               <p>RAM: {selectedVariant?.ram}</p>
//               <p>Storage: {selectedVariant?.storage}</p>
//             </div>

//             <div className="border p-4 rounded-xl">
//               <h3 className="font-semibold mb-2">Connectivity</h3>
//               <p>WiFi: Yes</p>
//               <p>Bluetooth: Yes</p>
//               <p>USB Ports: 3</p>
//             </div>

//             <div className="border p-4 rounded-xl">
//               <h3 className="font-semibold mb-2">Display</h3>
//               <p>Size: 14 inch</p>
//               <p>Resolution: HD</p>
//             </div>

//           </div>

//         </div>

//         {/* 🔥 RECOMMENDED */}
//         <div className="mt-10">

//           <h2 className="text-xl font-bold mb-4">
//             Recommended Products
//           </h2>

//           <Swiper
//             modules={[Autoplay]}
//             autoplay={{ delay: 2500 }}
//             spaceBetween={15}
//             breakpoints={{
//               0: { slidesPerView: 1.5 },
//               640: { slidesPerView: 2 },
//               768: { slidesPerView: 3 },
//               1024: { slidesPerView: 4 },
//             }}
//           >

//             {recommended.map((item) => (
//               <SwiperSlide key={item._id}>

//                 <div
//                   onClick={() => window.location.href = `/product/${item._id}`}
//                   className="bg-white rounded-xl p-3 shadow hover:shadow-lg transition cursor-pointer"
//                 >

//                   <img
//                     src={item.productImage?.[0]}
//                     alt=""
//                     className="h-32 mx-auto object-contain mb-3"
//                   />

//                   <p className="text-sm font-medium line-clamp-2">
//                     {item.productName}
//                   </p>

//                   <p className="text-red-600 font-semibold mt-1">
//                     ₹{item?.variants?.[0]?.price}
//                   </p>

//                 </div>

//               </SwiperSlide>
//             ))}

//           </Swiper>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ProductDetails;
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import displayINRCurrency from "../helpers/displayCurrency";
import addToCart from "../helpers/addToCart";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const ProductDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [qty, setQty] = useState(1);
  const [recommended, setRecommended] = useState([]);
  const [activeSpec, setActiveSpec] = useState("performance");

  // 🔥 FETCH PRODUCT
  const fetchProduct = async () => {
    const res = await fetch("https://lappyshop.onrender.com/api/product-details", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: id }),
    });

    const result = await res.json();
    const product = result.data;

    setData(product);

    if (product?.variants?.length > 0) {
      setSelectedVariant(product.variants[0]);
    }
  };

  // 🔥 FETCH RECOMMENDED
  const fetchRecommended = async () => {
    const res = await fetch("https://lappyshop.onrender.com/api/get-product");
    const result = await res.json();

    if (result.success) {
      setRecommended(result.data.slice(0, 10));
    }
  };

  useEffect(() => {
    fetchProduct();
    fetchRecommended();
  }, [id]);

  // 🔥 AUTO SLIDER
  useEffect(() => {
    if (!data?.productImage?.length) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % data.productImage.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [data]);

  const activeImage = data?.productImage?.[activeIndex];

  // 🔥 VARIANT CHANGE
  const handleVariantChange = (type, value) => {
    if (!data?.variants) return;

    let newVariant;

    if (type === "ram") {
      newVariant = data.variants.find(
        (v) => v.ram === value && v.storage === selectedVariant?.storage
      );
    } else {
      newVariant = data.variants.find(
        (v) => v.storage === value && v.ram === selectedVariant?.ram
      );
    }

    if (newVariant) setSelectedVariant(newVariant);
  };

  const price = selectedVariant?.price || 0;
  const actual = data?.price || price;

  const discount =
    actual > price ? Math.round(((actual - price) / actual) * 100) : 0;

  return (
    <div className="bg-[#f6f7fb] min-h-screen py-6 px-3">

      <div className="max-w-7xl mx-auto">

        {/* 🔥 TOP */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-white rounded-2xl p-5 shadow">

          {/* IMAGE */}
          <div>
            <div className="relative group overflow-hidden rounded-xl bg-gray-100">
              <motion.img
                key={activeImage}
                src={activeImage}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="w-full h-[300px] md:h-[420px] object-contain group-hover:scale-110 transition"
              />
            </div>

            <div className="flex gap-2 mt-3 overflow-x-auto">
              {data?.productImage?.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  onClick={() => setActiveIndex(i)}
                  className={`w-16 h-16 rounded border cursor-pointer 
                  ${activeIndex === i ? "border-red-500" : ""}`}
                />
              ))}
            </div>
          </div>

          {/* DETAILS */}
          <div>

            <h1 className="text-xl md:text-2xl font-bold">
              {data.productName}
            </h1>

            {/* PRICE */}
            <div className="mt-3">
              <p className="text-3xl font-bold text-red-600">
                {displayINRCurrency(price)}
              </p>

              <div className="flex gap-3 text-sm">
                <span className="line-through text-gray-400">
                  {displayINRCurrency(actual)}
                </span>
                <span className="text-green-600 font-semibold">
                  {discount}% OFF
                </span>
              </div>
            </div>

            {/* VARIANTS */}
            <div className="mt-5">

              <p className="font-medium">RAM</p>
              <div className="flex gap-2 flex-wrap mt-2">
                {[...new Set(data?.variants?.map(v => v.ram))].map((ram) => (
                  <button
                    key={ram}
                    onClick={() => handleVariantChange("ram", ram)}
                    className={`px-4 py-1 rounded-lg border 
                    ${selectedVariant?.ram === ram ? "bg-black text-white" : ""}`}
                  >
                    {ram}
                  </button>
                ))}
              </div>

              <p className="font-medium mt-4">Storage</p>
              <div className="flex gap-2 flex-wrap mt-2">
                {[...new Set(data?.variants?.map(v => v.storage))].map((s) => (
                  <button
                    key={s}
                    onClick={() => handleVariantChange("storage", s)}
                    className={`px-4 py-1 rounded-lg border 
                    ${selectedVariant?.storage === s ? "bg-black text-white" : ""}`}
                  >
                    {s}
                  </button>
                ))}
              </div>

            </div>

            {/* QTY */}
            <div className="flex gap-3 mt-5 items-center">
              <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>-</button>
              <span>{qty}</span>
              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>

            {/* BUTTONS */}
            <div className="flex gap-3 mt-6 flex-col sm:flex-row">

              <button
                onClick={() => addToCart(data._id, selectedVariant, dispatch, qty)}
                className="flex-1 bg-red-600 text-white py-3 rounded-xl hover:scale-105 transition"
              >
                Add to Cart
              </button>

              <button
                onClick={() => {
                  addToCart(data._id, selectedVariant, dispatch, qty);
                  window.location.href = "/checkout";
                }}
                className="flex-1 bg-black text-white py-3 rounded-xl"
              >
                Buy Now
              </button>

            </div>

          </div>

        </div>

        {/* DESCRIPTION */}
        <div className="bg-white mt-6 p-5 rounded-xl shadow">
          <h2 className="text-lg font-semibold">Description</h2>
          <p className="text-gray-600 mt-2">
            {data.description}
          </p>
        </div>

        {/* 🔥 SPECIFICATIONS FIXED */}
        {/* <div className="bg-white mt-6 p-5 rounded-xl shadow">

          <h2 className="text-lg font-semibold mb-4">
            Technical Specifications
          </h2>

          <div className="grid md:grid-cols-3 gap-4">

            <SpecCard title="Performance" data={data?.specifications?.performance} />
            <SpecCard title="Connectivity" data={data?.specifications?.connectivity} />
            <SpecCard title="Display" data={data?.specifications?.display} />

          </div>

        </div> */}
<div className="bg-white mt-6 p-5 rounded-xl shadow">

  <h2 className="text-lg font-semibold mb-4">
    Technical Specifications
  </h2>

  {/* 🔥 MOBILE TABS */}
  <div className="flex md:hidden gap-2 mb-4">

    {["performance", "connectivity", "display"].map((tab) => (
      <button
        key={tab}
        onClick={() => setActiveSpec(tab)}
        className={`flex-1 py-2 rounded-lg text-sm font-medium transition
        ${
          activeSpec === tab
            ? "bg-black text-white"
            : "bg-gray-100"
        }`}
      >
        {tab.charAt(0).toUpperCase() + tab.slice(1)}
      </button>
    ))}

  </div>

  {/* 🔥 MOBILE VIEW */}
  <div className="md:hidden">
    <SpecCard
      title={activeSpec}
      data={data?.specifications?.[activeSpec]}
    />
  </div>

  {/* 🔥 DESKTOP VIEW */}
  <div className="hidden md:grid grid-cols-3 gap-4">

    <SpecCard
      title="Performance"
      data={data?.specifications?.performance}
    />

    <SpecCard
      title="Connectivity"
      data={data?.specifications?.connectivity}
    />

    <SpecCard
      title="Display"
      data={data?.specifications?.display}
    />

  </div>

</div>
        {/* RECOMMENDED */}
        <div className="mt-10">

          <h2 className="text-xl font-bold mb-4">
            Recommended Products
          </h2>

          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 2500 }}
            spaceBetween={15}
            breakpoints={{
              0: { slidesPerView: 1.5 },
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >

            {recommended.map((item) => (
<SwiperSlide key={item._id}>
  <div
    onClick={() => navigate(`/product/${item._id}`)}
    className="bg-white rounded-xl p-3 shadow hover:shadow-lg transition cursor-pointer"
  >

    <img
      src={item.productImage?.[0]}
      className="h-32 mx-auto object-contain mb-3"
    />

    <p className="text-sm font-medium line-clamp-1">
      {item.productName}
    </p>

    <p className="text-red-600 text-sm font-semibold">
      ₹{item?.variants?.[0]?.price}
    </p>
   <div className="flex justify-center mt-3">
  <button
    className="bg-blue-600 text-white px-5 py-2 rounded-lg text-sm hover:bg-blue-700 transition"
  >
    View Product
  </button>
</div>

  </div>
</SwiperSlide>
            ))}

          </Swiper>

        </div>

      </div>

    </div>
  );
};

export default ProductDetails;



// 🔥 SPEC CARD COMPONENT
const SpecCard = ({ title, data }) => {

  if (!data) return null;

  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      className="border p-4 rounded-xl bg-gray-50 hover:shadow-md transition"
    >

      <h3 className="font-semibold mb-3">{title}</h3>

      {Object.entries(data).map(([key, value]) => {

        if (!value) return null;

        return (
          <div key={key} className="flex justify-between border-b py-1 text-sm">
            <span className="text-gray-500 capitalize">
              {key.replace(/([A-Z])/g, " $1")}
            </span>
            <span className="font-medium">{value}</span>
          </div>
        );
      })}

    </motion.div>
  );
};